import request from '@/utils/request'

export function businessGroupList(data) {
  return request({
    url: 'crm/business_status/type',
    method: 'post',
    data: data
  })
}

export function businessGroupAdd(data) {
  return request({
    url: 'crm/business_status/save',
    method: 'post',
    data: data
  })
}

/** 商機狀態組詳情 */
export function businessGroupRead(data) {
  return request({
    url: 'crm/business_status/read',
    method: 'post',
    data: data
  })
}

// 商機狀態組編輯
export function businessGroupUpdate(data) {
  return request({
    url: 'crm/business_status/update',
    method: 'post',
    data: data
  })
}

/** 商機狀態組刪除 */
export function businessGroupDelete(data) {
  return request({
    url: 'crm/business_status/delete',
    method: 'post',
    data: data
  })
}

/** 自定義欄位（欄位數據）的新增編輯操作 */
export function customFieldHandle(data) {
  return request({
    url: 'admin/field/update',
    method: 'post',
    data: data
  })
}

/** 自定義欄位（欄位數據）的詳情 */
export function customFieldList(data) {
  return request({
    url: 'admin/field/read',
    method: 'post',
    data: data
  })
}

/** 自定義欄位（欄位數據）的列表更新時間 */
export function customFieldIndex(data) {
  return request({
    url: 'admin/field/index',
    method: 'post',
    data: data
  })
}

/** 產品類別 數據獲取 */
export function productCategoryIndex(data) {
  return request({
    url: 'crm/product_category/index',
    method: 'post',
    data: data
  })
}

/** 產品分類新增*/
export function productCategorySave(data) {
  return request({
    url: 'crm/product_category/save',
    method: 'post',
    data: data
  })
}

/** 產品分類編輯*/
export function productCategoryUpdate(data) {
  return request({
    url: 'crm/product_category/update',
    method: 'post',
    data: data
  })
}

/** 產品分類刪除*/
export function productCategoryDelete(data) {
  return request({
    url: 'crm/product_category/delete',
    method: 'post',
    data: data
  })
}

/** 客戶保護規則*/
export function crmSettingConfig(data) {
  return request({
    url: 'crm/setting/config',
    method: 'post',
    data: data
  })
}

/** 客戶保護規則*/
export function crmSettingConfigData(data) {
  return request({
    url: 'crm/setting/configData',
    method: 'post',
    data: data
  })
}

/**
 * 部門業績目標列表
 * @param {*} data
 * year 年
 * status 1銷售（目標）2回款（目標）
 * id 部門ID
 */
export function crmAchievementIndex(data) {
  return request({
    url: 'crm/achievement/index',
    method: 'post',
    data: data
  })
}

/**
 * 業績目標編輯介面
 * @param {*} data
 * datalist 對應陣列
 */
export function crmAchievementUpdate(data) {
  return request({
    url: 'crm/achievement/update',
    method: 'post',
    data: data
  })
}

/**
 * 員工業績目標列表
 * @param {*} data
 * year 年
 * status 1銷售（目標）2回款（目標）
 * user_id 員工ID
 * structure_id 部門ID
 */
export function crmAchievementIndexForuser(data) {
  return request({
    url: 'crm/achievement/indexForuser',
    method: 'post',
    data: data
  })
}

/**
 * 記錄型別 數據
 * @param {*} data
 */
export function crmSettingRecordListAPI(data) {
  return request({
    url: 'crm/setting/recordList',
    method: 'post',
    data: data
  })
}

/**
 * 記錄型別 編輯
 * @param {*} data
 */
export function crmSettingRecordEditAPI(data) {
  return request({
    url: 'crm/setting/recordEdit',
    method: 'post',
    data: data
  })
}

/**
 * 合同到期提醒 設定
 * @param {*} data
 */
export function crmSettingContractDayAPI(data) {
  return request({
    url: 'crm/setting/contractDay',
    method: 'post',
    data: data
  })
}

/**
 * 擁有、鎖定客戶數限制
 * @param {*} data
 */
export function crmSettingCustomerConfigListAPI(data) {
  return request({
    url: 'crm/setting/customerConfigList',
    method: 'post',
    data: data
  })
}

/**
 * 擁有、鎖定客戶數限制 - 建立
 * @param {*} data
 */
export function crmSettingCustomerConfigSaveAPI(data) {
  return request({
    url: 'crm/setting/customerConfigSave',
    method: 'post',
    data: data
  })
}

/**
 * 擁有、鎖定客戶數限制 - 編輯
 * @param {*} data
 */
export function crmSettingCustomerConfigUpdateAPI(data) {
  return request({
    url: 'crm/setting/customerConfigUpdate',
    method: 'post',
    data: data
  })
}

/**
 * 擁有、鎖定客戶數限制 - 刪除
 * @param {*} data
 */
export function crmSettingCustomerConfigDelAPI(data) {
  return request({
    url: 'crm/setting/customerConfigDel',
    method: 'post',
    data: data
  })
}
